import React from "react";
import { Layout } from "antd";
import PlayerTLNav from "./PlayerTLNav";

import { Outlet } from "react-router-dom";
const { Content } = Layout;
const PlayerTLayout = ({ userId }) => {
  // Id = view profile -player ,team etc
  return (
    <Layout>
      <div className="profile-header">
        <div className="layout-width">
          <PlayerTLNav userId={userId} />
        </div>
      </div>
      <Content className="layout-width">
        <Outlet />
      </Content>
      {/* <Footer style={{ backgroundColor: "#2F89FC" }}>
        <HomeFooter />  
      </Footer> */}
    </Layout>
  );
};

export default PlayerTLayout;
